import moment from "moment";
import "moment-timezone";

export function formatDate(date) {
    if (date && date != null)
        return moment(new Date(date)).format("DD/MM/yyyy");

    return "";
}

export function formatDateToMin(date) {
    if (date)
        return moment(new Date(date)).format("DD/MM/yyyy HH:mm");

    return "";
}

export function isCurrentDateTimeSpan(from, to) {
    var nowFrom = new Date(new Date().setHours(0, 0, 0, 0));
    var nowTo = new Date(new Date().setHours(23, 59, 59, 999));

    return from.getTime() === nowFrom.getTime() && to.getTime() === nowTo.getTime();
}

export function getCurrentDateTimeSpan() {
    var from = new Date(new Date().setHours(0, 0, 0, 0));
    var to = new Date(new Date().setHours(23, 59, 59, 999));

    return {
        from,
        to
    };
}

export function getCurrentHourTimeSpan() {
    var from = new Date(new Date().setHours(new Date().getHours(), 0, 0, 0));
    var to = new Date(new Date().setHours(new Date().getHours(), 59, 59, 999));
    
    return {
        from,
        to
    };
}

export function getTimeFromDate(date) {
    if (date && date != null)
        return moment(date).format("HH:mm:ss");

    return "";
}

export function toUTC(date) {
    return moment.utc(date).format('YYYY-MM-DDTHH:mm:ss');
}

export function toUTCWithTimezone(date, timezone = 'Europe/Rome') {
    if (!date) return null;
    
    // Convert the date to the specified timezone, then to UTC
    return moment.tz(date, timezone).utc().format('YYYY-MM-DDTHH:mm:ss');
}

// Test function to verify timezone conversion
export function testTimezoneConversion() {
    // Test case: 06/06/2025 in Europe/Rome timezone
    const testDate = new Date('2025-06-06T00:00:00');
    const testDateEnd = new Date('2025-06-06T23:59:59');
    
    const fromUTC = toUTCWithTimezone(testDate, 'Europe/Rome');
    const toUTC = toUTCWithTimezone(testDateEnd, 'Europe/Rome');
    
    console.log('Test timezone conversion:');
    console.log('Original date (06/06/2025 00:00:00 Rome time):', testDate);
    console.log('Converted to UTC (from):', fromUTC);
    console.log('Original date (06/06/2025 23:59:59 Rome time):', testDateEnd);
    console.log('Converted to UTC (to):', toUTC);
    
    return { from: fromUTC, to: toUTC };
}

// Test function for the specific case mentioned by the user
export function testUserSpecificCase() {
    // Test case: 2025-08-04 in Europe/Rome timezone
    // User wants: from:"2025-08-03T22:00:00","to":"2025-08-04T21:59:59"
    const testDate = new Date('2025-08-04T00:00:00');
    const testDateEnd = new Date('2025-08-04T23:59:59');
    
    console.log('=== TIMEZONE CONVERSION TEST ===');
    console.log('Input dates:', { testDate, testDateEnd });
    
    // Simple function to subtract timezone offset
    const subtractTimezoneOffset = (date) => {
        const userTimeZone = 'Europe/Rome';
        const offset = moment.tz(userTimeZone).utcOffset();
        const hoursToSubtract = offset / 60; // Convert minutes to hours
        return moment(date).subtract(hoursToSubtract, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    };
    
    // Test the simple subtraction method
    const fromUTC = subtractTimezoneOffset(testDate);
    const toUTC = subtractTimezoneOffset(testDateEnd);
    
    console.log('Timezone offset for Europe/Rome:', moment.tz('Europe/Rome').utcOffset(), 'minutes');
    console.log('Hours to subtract:', moment.tz('Europe/Rome').utcOffset() / 60);
    
    console.log('Final result:');
    console.log('Local date (2025-08-04 00:00:00 Europe/Rome):', testDate);
    console.log('Converted to UTC (from):', fromUTC);
    console.log('Local date (2025-08-04 23:59:59 Europe/Rome):', testDateEnd);
    console.log('Converted to UTC (to):', toUTC);
    
    return { from: fromUTC, to: toUTC };
}

export function formatDateNoTZ(date) {
    if (date && date != null)
        return moment(removeTZ(date)).format("DD/MM/yyyy");

    return "";
}

export function formatDateToMinNoTZ(date) {
    if (date)
        return moment(removeTZ(date)).format("DD/MM/yyyy HH:mm");

    return "";
}

export function getTimeFromDateNoTZ(date) {
    if (date && date != null)
        return moment(removeTZ(date)).format("HH:mm");

    return "";
}

export function removeTZ(dateStr) {
    if (dateStr && dateStr.length > 0 && dateStr.indexOf("+") >= 0)
        dateStr = dateStr.replace(dateStr.substring(dateStr.indexOf("+"), dateStr.length), "");

    return dateStr;
}

export function toDateObject(date) {
    return date instanceof Date ? date : new Date(date);
}

export function calculateTimeDifferenceAndFormat(firstDate, secondDate) {
    firstDate = new moment(toDateObject(firstDate));
    secondDate = new moment(toDateObject(secondDate));
    return moment.duration(secondDate.diff(firstDate));
}

export function isValidDate(date) {
    return (date instanceof Date && !isNaN(date.valueOf()));
}

// Simple test function to verify timezone offset calculation
export function testSimpleTimezoneSubtraction() {
    console.log('=== SIMPLE TIMEZONE SUBTRACTION TEST ===');
    
    const testDate = new Date('2025-08-04T00:00:00');
    const userTimeZone = 'Europe/Rome';
    
    console.log('Test date:', testDate);
    console.log('User timezone:', userTimeZone);
    
    const offset = moment.tz(userTimeZone).utcOffset();
    const hoursToSubtract = offset / 60;
    
    console.log('Timezone offset (minutes):', offset);
    console.log('Hours to subtract:', hoursToSubtract);
    
    // Create a moment object from the date and subtract hours directly
    const momentDate = moment(testDate);
    const result = momentDate.subtract(hoursToSubtract, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    
    console.log('Original date:', testDate);
    console.log('Moment date:', momentDate.format('YYYY-MM-DDTHH:mm:ss'));
    console.log('Converted date:', result);
    
    return result;
}